import axios from 'axios'
import Vue from 'vue'
import store from "../store/index";
const instance = axios.create({
  baseURL: 'http://gkb.gaozhaotong.cn',
  timeout: 100000
})
instance.interceptors.request.use(config => {
  let isLocalhost = window.location.href.indexOf("localhost") == -1
  let token = '';
  if (isLocalhost) {
    token = lycamWeb.getCookie("token");
  } else {
    token = store.state.myToken
  }

  console.log('这里来拿token ');
  console.log(token);
  if (token) {
    config.headers = config.headers || {}
    config.headers['token'] = token
    // config.responseType = 'blob'; // 设置返回类型blob
  }
  return config
}, err => Promise.reject(err))
instance.interceptors.response.use(res => {
    console.log(res);
  if (res.data.code !== 0) {
    console.log('统一处理一下报错');
    // 统一的网络请求报错处理
    // Vue.use(Element) 就在 Vue的prototype上面添加element相关的API
    Vue.prototype.$message.error(res.data.message)
  }
  return res.data
}, err => Promise.reject(err))
export default instance



// WEBPACK FOOTER //
// ./src/request/request.js